export const getDefault = () => {
  const schema = {
    name: 'Testimonials',
    title: 'Os nossos estudantes',
    resource: 'app.organism.testimonials.title',
    backgroundColor: '#F1F1F2',
    textColor: '#000',
    showHeader: true,
    titleProps: {
      hasLine: false,
      hasLink: false
    },
    data: [
      {
        textColor: '#000',
        backgroundColor: '#F1F1F2',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias animi atque.',
        person: {
          image: 'https://static.ua.pt/images/ua/placeholder-person.png',
          name: 'Nome A',
          about: 'Descrição',
          alt: ''
        }
      },
      {
        textColor: '#000',
        backgroundColor: '#F1F1F2',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias animi atque.',
        person: {
          image: 'https://static.ua.pt/images/ua/placeholder-person.png',
          name: 'Nome B',
          about: 'Descrição',
          alt: ''
        }
      },
      {
        textColor: '#000',
        backgroundColor: '#F1F1F2',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Alias animi atque.',
        person: {
          image: 'https://static.ua.pt/images/ua/placeholder-person.png',
          name: 'Nome C',
          about: 'Descrição',
          alt: ''
        }
      },
    ]
  }
  return schema
}
